import { IconWrapper } from '../runtime';
export default IconWrapper('market', true, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 48 48",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M24 3.00018L24.3489 3.00304C35.7257 3.1893 45 12.4679 45 24.074L44.9971 24.424C44.8086 35.8367 35.4189 45.0002 24 45.0002L23.6511 44.9973C12.2743 44.811 3 35.5318 3 24.074C3 12.3495 12.4645 3.00018 24 3.00018ZM38.3795 25.3873L21.0667 29.7236C20.9031 29.7647 20.7389 29.7839 20.5776 29.7839L20.3895 29.775C19.9542 29.7338 19.5478 29.551 19.2294 29.2627L17.5405 35.1412L17.5176 35.2718C17.3081 36.7882 19.0777 38.028 20.9166 37.0902L36.8999 27.9968L37.0914 27.8822C38.2023 27.1817 38.6291 26.2589 38.3795 25.3873ZM17.9799 12.7781C16.7704 11.8506 14.8215 12.7632 14.7143 14.82L14.5981 33.2086C14.5891 34.6499 15.1893 35.5632 16.1184 35.7939L21.0193 18.6333L21.0736 18.4695C21.2962 17.883 21.7718 17.4537 22.337 17.2727L18.091 12.8704L17.9799 12.7781ZM21.0617 11.2795C19.8993 10.6677 18.887 10.7597 18.2574 11.4122L30.6688 24.2365C31.1534 24.7369 31.3249 25.4251 31.1884 26.0586L37.1238 24.5818L37.2594 24.5317C38.667 23.9481 38.8508 21.8041 37.1238 20.6833L21.2568 11.388L21.0617 11.2795Z",
      "fill": props.colors[0]
    }
  })]);
});